/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITY_LIST,
    '/api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );
export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const showMunicipalitySelected = (id, payload, callback) =>
  req.item(
    c.GET_MUNICIPALITY_SELECTED,
    `/api/v1/administrators/address/municipalities/${id}`,
    payload,
    callback
  );

export const clearTransaction = () =>
  req.setList(c.GET_MUNICIPALITY_SELECTED, []);

export const updateMunicipality= (id, payload, callback) =>
  req.update(
    c.UPDATE_MUNICIPALITY,
    `/api/v1/administrators/address/municipalities/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );